// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/notice.css
// module id = 2634
// module chunks = 2